import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ae-tabs-item',
  template: ` <li>
    <a href="#"><ng-content></ng-content></a>
  </li>`,
  styles: [],
})
export class AeTabsItemComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
